import React from 'react';
import {InteractiveTileImagePreloadDeprecated} from '../../../features/ProductStream/Tiles/InteractiveTileImagePreloadDeprecated';
import {useOnColorHoverDeprecated} from '../../../features/ProductStream/Tiles/hooks/useOnColorHoverDeprecated';
import {
  WishlistProductTile,
  WishlistProductTileProps,
} from './WishlistProductTile';

export const InteractiveWishlistProductTile: React.FC<
  WishlistProductTileProps
> = ({tile: initialTile, itemsPreferences, ...rest}) => {
  const {
    onHover: onColorHover,
    tile: hoveredTile,
    resetTile,
    loaded,
    onImageLoad,
    soldOut: soldOutColorProductId,
  } = useOnColorHoverDeprecated(initialTile);

  return (
    <>
      <WishlistProductTile
        tile={loaded && hoveredTile ? hoveredTile : initialTile}
        {...rest}
        onColorHover={onColorHover}
        onColorLeave={resetTile}
        productTileGalleryMode={
          hoveredTile && hoveredTile.product.id !== initialTile.product.id
            ? undefined
            : rest.productTileGalleryMode
        }
        itemsPreferences={itemsPreferences}
        soldOutColorProductId={soldOutColorProductId}
      />
      {hoveredTile && !loaded && (
        <InteractiveTileImagePreloadDeprecated
          onImageLoad={onImageLoad}
          tile={hoveredTile}
          itemsPreferences={itemsPreferences}
          data-testid="WishlistInteractiveProductTile-preload-image"
        />
      )}
    </>
  );
};
